// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3f9Ky","image":"style_image__aiT4A","brand":"style_brand__2MV5O","number":"style_number__3FHsj"};